export const setMapConfig = (mapConfig) => sessionStorage.setItem('mapConfig', JSON.stringify(mapConfig));
export const getMapConfig = (props) => {
    const { defaultValue, parse = true } = props || {};
	const mapConfig = parse ? JSON.parse(sessionStorage.getItem('mapConfig')) : sessionStorage.getItem('mapConfig');
	return mapConfig || defaultValue;
};
